import { ImageField } from '@prismicio/client';

export const getImageAspectRadio = (image: ImageField) =>
  image.dimensions!.width / image.dimensions!.height;
